(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hat-size-widget-impulse"] && !Shopify.designMode) return;
  try {
    
(() => {
  /* 1. Threshold Logic -------------------------------------------- */
  const advise = val => {
    if (val > 61.4) return null; // Hard cap

    if (val < 54.5) return {cm:54, sym:'XS', txt:'Extra Small'};
    if (val <= 55.4) return {cm:55, sym:'S', txt:'Small'};
    if (val <= 56.4) return {cm:56, sym:'S/M', txt:'Small to Medium'};
    if (val <= 57.4) return {cm:57, sym:'M', txt:'Medium'};
    if (val <= 58.4) return {cm:58, sym:'M/L', txt:'Medium to Large'};
    if (val <= 59.4) return {cm:59, sym:'L', txt:'Large'};
    if (val <= 60.4) return {cm:60, sym:'L/XL', txt:'Large to Extra Large'};
    if (val <= 61.4) return {cm:61, sym:'L/XL', txt:'Large to Extra Large'};

    return null;
  };

  const $input = document.getElementById('head-input');
  const $btn   = document.getElementById('size-calc-btn');
  const $resContainer = document.getElementById('result-container');
  const $resMain = document.getElementById('result-main');
  const $resAlt  = document.getElementById('result-alt');
  const $wrap  = document.getElementById('browse-wrap');
  const $link  = document.getElementById('browse-link');
  const $span  = document.getElementById('browse-size');
  const $grid  = document.getElementById('recos');

  const COLL = 'shop-sunhats-collection';
  const MAX_PRODUCTS = 8;

    /* 2. Language detection ---------------------------------------- */
  const getLang = () => {
  /* 1. Try <html lang="..."> */
  const htmlLang = (document.documentElement.getAttribute('lang') || '').toLowerCase();
  if (htmlLang.startsWith('de')) return 'de';
  if (htmlLang.startsWith('nl')) return 'nl';
  if (htmlLang.startsWith('fr')) return 'fr';

  /* 2. Try PayPal metadata locale, e.g. de_DE */
  const paypalLocale =
    (document.querySelector('#in-context-paypal-metadata')?.dataset?.locale || '').toLowerCase();
  if (paypalLocale.startsWith('de')) return 'de';
  if (paypalLocale.startsWith('nl')) return 'nl';
  if (paypalLocale.startsWith('fr')) return 'fr';

  /* 3. Try alternate hreflang that matches current page URL */
  const currentUrl = window.location.origin + window.location.pathname;
  const hreflangLinks = document.querySelectorAll('link[rel="alternate"][hreflang]');

  for (const link of hreflangLinks) {
    const href = (link.getAttribute('href') || '').replace(/\/$/, '');
    const hreflang = (link.getAttribute('hreflang') || '').toLowerCase();

    if (href === currentUrl.replace(/\/$/, '')) {
      if (hreflang.startsWith('de')) return 'de';
      if (hreflang.startsWith('nl')) return 'nl';
      if (hreflang.startsWith('fr')) return 'fr';
      if (hreflang.startsWith('en')) return 'en';
    }
  }

  /* 4. Fallback on hostname */
  const host = window.location.hostname.toLowerCase();
  if (host.startsWith('de.')) return 'de';
  if (host.startsWith('nl.')) return 'nl';
  if (host.startsWith('fr.')) return 'fr';

  /* 5. Last fallback */
  return 'en';
};

const lang = getLang();

  const translations = {
    en: {
      recommended: 'Recommended',
      basedOnYour: 'Based on your',
      youCouldAlsoTry: 'you could also try',
      comfyFit: 'Our Comfy-Fit band lets you tighten the fit by approx. 1.5 cm for maximum comfort.',
      invalidMeasurement: 'Please enter a valid measurement (e.g., 57.5)',
      aboveMax: 'Sorry, we don’t currently stock a hat for measurements above 61.4cm.',
      sizes: {
        'Extra Small': 'Extra Small',
        'Small': 'Small',
        'Small to Medium': 'Small to Medium',
        'Medium': 'Medium',
        'Medium to Large': 'Medium to Large',
        'Large': 'Large',
        'Large to Extra Large': 'Large to Extra Large'
      }
    },
    de: {
      recommended: 'Empfohlen',
      basedOnYour: 'Basierend auf Ihrem Kopfumfang von',
      youCouldAlsoTry: 'könnten Sie auch',
      comfyFit: 'Unser Comfy-Fit-Band ermöglicht es Ihnen, die Passform für maximalen Komfort um ca. 1,5 cm enger zu stellen.',
      invalidMeasurement: 'Bitte geben Sie ein gültiges Maß ein, z. B. 57,5',
      aboveMax: 'Leider führen wir derzeit keine Hüte für einen Kopfumfang über 61,4 cm.',
      sizes: {
        'Extra Small': 'Extra Klein',
        'Small': 'Klein',
        'Small to Medium': 'Klein bis Mittel',
        'Medium': 'Mittel',
        'Medium to Large': 'Mittel bis Groß',
        'Large': 'Groß',
        'Large to Extra Large': 'Groß bis Extra Groß'
      }
    },
    nl: {
      recommended: 'Aanbevolen',
      basedOnYour: 'Op basis van uw hoofdomtrek van',
      youCouldAlsoTry: 'kunt u ook',
      comfyFit: 'Met onze Comfy-Fit-band kunt u de pasvorm met ca. 1,5 cm aansnoeren voor maximaal comfort.',
      invalidMeasurement: 'Voer een geldige maat in, bijvoorbeeld 57,5',
      aboveMax: 'Sorry, wij hebben momenteel geen hoeden voor een hoofdomtrek groter dan 61,4 cm.',
      sizes: {
        'Extra Small': 'Extra Klein',
        'Small': 'Klein',
        'Small to Medium': 'Klein tot Medium',
        'Medium': 'Medium',
        'Medium to Large': 'Medium tot Groot',
        'Large': 'Groot',
        'Large to Extra Large': 'Groot tot Extra Groot'
      }
    },
    fr: {
      recommended: 'Recommandé',
      basedOnYour: 'Sur la base de votre tour de tête de',
      youCouldAlsoTry: 'vous pouvez aussi essayer',
      comfyFit: 'Notre bande Comfy-Fit vous permet d’ajuster le chapeau d’environ 1,5 cm pour un confort optimal.',
      invalidMeasurement: 'Veuillez saisir une mesure valide, par exemple 57,5',
      aboveMax: 'Désolé, nous n’avons actuellement pas de chapeaux pour un tour de tête supérieur à 61,4 cm.',
      sizes: {
        'Extra Small': 'Très Petit',
        'Small': 'Petit',
        'Small to Medium': 'Petit à Moyen',
        'Medium': 'Moyen',
        'Medium to Large': 'Moyen à Grand',
        'Large': 'Grand',
        'Large to Extra Large': 'Grand à Très Grand'
      }
    }
  };

  const t = translations[lang];

  /* 3. UI Helpers ------------------------------------------------- */
  const hideAll = () => {
    $resContainer.style.display = 'none';
    $wrap.style.display = 'none';
    $grid.style.display = 'none';
    document.querySelectorAll('.hat-card').forEach(c => c.classList.add('is-hidden'));
  };

  const checkMatch = (el, size) => {
    const tags = el.dataset.sizes || '';
    return tags.includes(`size ${size}`) || tags.includes(`size_${size}`);
  };

  const render = (prim, alt, mainHtml, altHtml) => {
    $resMain.innerHTML = mainHtml;
    $resAlt.innerHTML = altHtml;
    $resContainer.style.display = 'block';

    const browseTarget = alt || prim;
    $link.href = `/collections/${COLL}/Size_${browseTarget}-cm`;
    $span.textContent = browseTarget;
    $wrap.style.display = 'block';

    let shown = 0;
    const cards = document.querySelectorAll('.hat-card');

    // Pass 1: Primary
    cards.forEach(card => {
      if (shown < MAX_PRODUCTS && checkMatch(card, prim)) {
        card.classList.remove('is-hidden');
        shown += 1;
      } else {
        card.classList.add('is-hidden');
      }
    });

    // Pass 2: Alternative
    if (alt && shown < MAX_PRODUCTS) {
      cards.forEach(card => {
        if (card.classList.contains('is-hidden') && shown < MAX_PRODUCTS && checkMatch(card, alt)) {
          card.classList.remove('is-hidden');
          shown += 1;
        }
      });
    }

    $grid.style.display = shown > 0 ? 'block' : 'none';
    window.dispatchEvent(new Event('resize'));
  };

  /* 4. Main Action ------------------------------------------------ */
  const run = () => {
    hideAll();
    const raw = $input.value.replace(',', '.').trim();
    const val = parseFloat(raw);

    if (isNaN(val) || val < 45) {
      alert(t.invalidMeasurement);
      return;
    }

    const rec = advise(val);
    if (!rec) {
      alert(t.aboveMax);
      return;
    }

    let alt = null;

    if (rec.cm < 61) {
      alt = rec.cm + 1;
    }

    const translatedSizeText = t.sizes[rec.txt] || rec.txt;

    const mainText = `${t.recommended}: ${rec.cm} cm – ${rec.sym} <span style="font-weight:normal; font-size:0.9em;">(${translatedSizeText})</span>`;
    const altText  = alt ? `${t.basedOnYour} ${val.toFixed(1)} cm, ${t.youCouldAlsoTry} <strong>${alt} cm</strong>. ${t.comfyFit}` : '';

    render(rec.cm, alt, mainText, altText);
  };

  $btn.addEventListener('click', run);
  $input.addEventListener('keyup', e => { if (e.key === 'Enter') run(); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hat-size-widget"] && !Shopify.designMode) return;
  try {
    
(() => {
    /* 1. Size & label logic ----------------------------------------- */
    const advise = cm => {
    const m = Math.ceil(cm);
    if (m < 55)  return {cm:54,sym:'XS',  txt:'Extra Small'};           // still 54 cm bucket
    if (m <= 56) return {cm:56,sym:'S/M', txt:'Small to Medium'};       // 54.5–56 ⇒ 56 cm
    if (m <= 58) return {cm:m,sym:'M/L', txt:'Medium to Large'};        // 56.1–58 ⇒ 57‑58
    if (m <= 61) return {cm:m === 59 ? 60 : m, sym:'L/XL',txt:'Large to Extra Large'}; // 59 ⇒ 60; 60‑61 keep
    if (m === 63) return {cm:63,sym:'XXL',txt:'Extra Extra Large'};
        return null;                                                       // outside supported range
  };

  /* 2. DOM refs ----------------------------------------------------- */
  const $input = document.getElementById('head-input');
  const $btn   = document.getElementById('size-calc-btn');
  const $res   = document.getElementById('result');
  const $wrap  = document.getElementById('browse-wrap');
  const $link  = document.getElementById('browse-link');
  const $span  = document.getElementById('browse-size');
  const $grid  = document.getElementById('recos');

  const COLL = 'shop-sunhats-collection';
  const tpl  = s => (document.querySelector(`template[data-size='${s}']`)||{}).innerHTML||'';

  /* 3. UI helpers --------------------------------------------------- */
  const render = (prim, alt, html) => {
    const target = alt || prim; // browse link should point to alt if present
    $res.innerHTML = html; $res.style.display='';
    $link.href = `/collections/${COLL}/Size_${target}-cm`;
    $span.textContent = target;
    $wrap.style.display='';

    const cards = tpl(prim) + (alt ? tpl(alt) : '');
    if (cards.trim()) { $grid.innerHTML = cards; $grid.style.display=''; }
    else { $grid.style.display='none'; }
  };
  const hide = () => { $res.style.display=$wrap.style.display=$grid.style.display='none'; };

  /* 4. Main --------------------------------------------------------- */
  const run = () => {
    hide();
    const raw = $input.value.replace(',', '.').trim();
    const val = parseFloat(raw);
        if (isNaN(val)) { alert('Please enter a valid number in centimetres.'); return; }
    if (val < 54.5 || val > 61.4) { alert('Sorry, we don’t currently stock a hat for that measurement.'); return; }

    const rec = advise(val);
    if (!rec) { alert('Sorry, we don’t currently stock a hat for that measurement.'); return; }

            let alt = null;
    // alt for 59.5‑60 ⇒ suggest 61
    if (rec.cm === 60 && val >= 59.5 && val <= 60) alt = 61;
    // alt for 56.5‑57 ⇒ suggest 58
    if (rec.cm === 57 && val >= 56.5)            alt = 58;

    /* ----- GA4 / GTM event ----- */
    const eventPayload = {
      event: 'hat_size_recommended',          // GTM event name
      measurement_value: val.toFixed(1),      // e.g. 59.6
      size_primary: rec.cm.toString(),        // "60"
      size_alt: alt ? alt.toString() : ''     // "61" or empty
    };
    if (window.dataLayer && Array.isArray(window.dataLayer)) {
      window.dataLayer.push(eventPayload);
    } else if (typeof window.gtag === 'function') {
      window.gtag('event', 'hat_size_recommended', {
        measurement_value: val.toFixed(1),
        size_primary: rec.cm,
        size_alt: alt || ''
      });
    }

    const mainText = `Based on your ${val.toFixed(1)} cm measurement we recommend <strong>${rec.cm} cm – ${rec.sym}</strong> (${rec.txt}).`;
    const altText  = alt ? `<br>You could also try <strong>${alt} cm</strong>; our Comfy‑Fit band lets you tighten by ≈1.5 cm for a secure fit.` : '';

    render(rec.cm, alt, mainText + altText);
  };

  $btn.addEventListener('click', run);
  $input.addEventListener('keyup', e => { if (e.key==='Enter') run(); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();
})();
